import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect, useRef } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import './SettingStyles.css';
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { useSidebar } from "../../SidebarContext";
import { toast } from "react-toastify";
import ReactQuill from "react-quill-new";
import DOMPurify from 'dompurify';
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import ProfileSetting from "./ProfileSetting";
import HelpAndSupport from "./HelpAndSupport";
import DeliverySettings from "./DeliverySettings";
import CartButtonOptions from "./CartButtonOptions";
import PaymentButtonOptions from "./PaymentButtonOptions";
import GstInlineSetting from "./GstSetting";
import MetaDetails from "./MetaDetails";
import Loader from "../Loader";
import PaymentGateway from "./PaymentGateway";
import LoginPass from "./LoginPass";
import LoginBanner from "./LoginBanner";
import TwoStepVerification from "./TwoStepVerification";
import { decryptToken } from "../utils/getToken";
import SettingsBankAndSign from "./BankDetail";
import WalletUsageSetting from "./WalletUsage";
import CartCheckSetting from "./CartCheck";
import RegisterSetting from "./RegisterSetting";
import SMSSetting from "./SMSSetting";
import { richTextForQuill } from "../utils/richTextForQuill";


const tabList = [
    "Profile Information",
    "Help & Support Contacts",
    "Delivery Settings (Cash Before Pay + Free Delivery)",
    "Cart Button Options",
    "Payment Button Options",
    "GST Configuration",
    "Meta Details",
    "Payment Gateway (Razorpay)",
    "Login Mail & Passkey",
    "Wallet Usage",
    "Coupon & Coin Setting",
    "Login & Register Setting",
     "SMS Setting",
    "Bank Deails & Authorised Signatory",
     "Login Banner",
    "2-Step Verification",
];

const SettingUpdated = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const url = API_BASE_URL;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    console.log(isLoggedIn)
    const [userData, setUserData] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [editMode1, setEditMode1] = useState(false);
    const [editMode1cart, setEditMode1cart] = useState(false);
    const [formData, setFormData] = useState({});
    const [help, setHelp] = useState({})
    const [Emailpass, setEmailPass] = useState({})
    const [userDatahelp, setUserDatahelp] = useState(null);
    const [Emailpasshelp, setEmailpasshelp] = useState(null);
    const [useTextLogo, setUseTextLogo] = useState(false);

    const [deliveryPayData, setDeliveryPayData] = useState({});
    const [editDelivery, setEditDelivery] = useState(false);
    const autocompleteRef = useRef(null);
    const [deliveryRanges, setDeliveryRanges] = useState([]);
    const [newRange, setNewRange] = useState([{ price: "", min_km: "", max_km: "" }]);
    const [editId, setEditId] = useState(null);
    const [submittedRanges, setSubmittedRanges] = useState([]);
    const [cartButtons, setCartButtons] = useState([]);
    const [editButtonData, setEditButtonData] = useState(null);
    const [payButtons, setPayButtons] = useState([]);
    const [walletUsage, setWalletUsage] = useState([])
    const [editpayButtonData, setpayEditButtonData] = useState(null);
    const [gstData, setGstData] = useState({ gstPercent: "" });
    const [editGst, setEditGst] = useState(false);
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: ["places"],
    });
    const [originalFormData, setOriginalFormData] = useState(null);
    const [hasChanges, setHasChanges] = useState(false);
    const [meta, setMeta] = useState({});
    const [sms, setSms] = useState({});
    const [userMetaData, setUserMetaData] = useState(null);
    const [loading, setLoading] = useState(false)
    const [razorpayData, setRazorpayData] = useState({ key_id: "", key_secret: "", company_color: "", company_name: "" });
    const [editPayment, setEditPayment] = useState(false);
    const [enabled, setEnabled] = useState(false);
    const [error, setErrors] = useState({})
    const [checkData, setCheckData] = useState({
        coupon_apply: true,
        coin_apply: true
    })
    const [registerSetting, setRegisterSetting] = useState({
        email: true,
        phone: false,
    })



    useEffect(() => {
        if (!originalFormData) return;
        const hasDiff = JSON.stringify(formData) !== JSON.stringify(originalFormData);
        setHasChanges(hasDiff);
    }, [formData, originalFormData]);

    const token = decryptToken("accessToken") || ""
    console.log(token)

    const fetchSingleuser = async () => {
        try {
            const response = await fetch(`${url}/register/single/${isLoggedIn.main_id}`, {
                method: "GET",

                headers: {
                    Authorization: `Bearer ${token}`,
                },

            });
            const res = await response.json();
            const u = res.users;
            setUserData(u);
            const custom_note =
                typeof u?.custom_note === "string"
                    ? u.custom_note
                    : richTextForQuill(u?.custom_note);
            const normalized = { ...u, custom_note };
            setFormData(normalized);
            setOriginalFormData(normalized);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchHelpuser = async () => {
        try {
            const response = await fetch(`${url}/help/single/${isLoggedIn.main_id}`);
            const res = await response.json();

            console.log(res.help)
            setUserDatahelp(res.help);
            setHelp(res.help);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchEmailpassuser = async () => {
        if (!isLoggedIn?.main_id || !token) return;
        try {
            const response = await fetch(`${url}/login-cred/${isLoggedIn.main_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const res = await response.json().catch(() => ({}));
            if (response.ok) {
                setEmailpasshelp(res);
                setEmailPass(res);
            } else if (response.status === 404) {
                setEmailpasshelp(null);
                setEmailPass({});
            }
        } catch (error) {
            console.warn("login-cred fetch failed:", error?.message || error);
        }
    };
    const extractSrc = (input) => {
        if (typeof input !== "string") return "";
        const match = input.match(/src=["'](.*?)["']/);
        return match?.[1] || input.trim();
    };

    const fetchMetaData = async () => {
        if (!isLoggedIn?.main_id) return;
        try {
            const response = await fetch(`${url}/meta/${isLoggedIn.main_id}`);
            const text = await response.text();
            let res;
            try {
                res = JSON.parse(text);
            } catch {
                return;
            }
            if (!res || res.isError || res.data == null) return;

            let scripts = [];

            if (Array.isArray(res.data.scripts)) {
                scripts = res.data.scripts.map((s) => {
                    if (!s) return "";
                    if (typeof s !== "string") return "";
                    const match = s.match(/src=["'](.*?)["']/);
                    return match?.[1] || s.trim();
                });
            } else if (typeof res.data.scripts === "string") {
                try {
                    const parsed = JSON.parse(res.data.scripts);
                    if (Array.isArray(parsed)) {
                        scripts = parsed.map((s) => {
                            if (typeof s !== "string") return "";
                            const match = s.match(/src=["'](.*?)["']/);
                            return match?.[1] || s.trim();
                        });
                    }
                } catch (err) {
                    console.warn("Script JSON parse error", err);
                }
            }

            const cleanMeta = {
                ...res.data,
                scripts: scripts,
            };

            setUserMetaData(cleanMeta);
            setMeta(cleanMeta);
        } catch (error) {
            console.warn("Meta fetch failed (check API URL, backend, and CORS):", error?.message || error);
        }
    };

    const fetchsmssetting = async () => {
        try {
            const res = await fetch(`${url}/sms`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const data = await res.json();
            if (res.ok) {
                console.log(data)
                setSms(data.data);
            }
        } catch (error) {
            console.error("Failed to fetch GST data", error);
        }
    }

    const fetchregistersetting = async () => {
        try {
            const res = await fetch(`${url}/register-setting`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const data = await res.json();
            if (res.ok) {
                console.log(data.data)
                setRegisterSetting({
                    email: data.data.email,
                    phone: data.data.phone
                });
            }
        } catch (error) {
            console.error("Failed to fetch register-setting data", error);
        }
    }

    const addDeliveryRange = () => {
        setNewRange([...newRange, { price: "", min_km: "", max_km: "" }]);
    };

    const updateDeliveryRange = (index, field, value) => {
        const updatedRanges = [...newRange];
        updatedRanges[index][field] = value;
        setNewRange(updatedRanges);
    };

    const saveEdit = async (id) => {
        const updated = deliveryRanges.find(r => r.id === id);
        const res = await fetch(`${url}/freedelivery/${id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updated),
        });
        const result = await res.json();
        if (!res.ok) return toast.error("Update failed");

        setEditId(null);
    };


    const submitDeliveryRanges = async () => {
        try {
            if (newRange.length > 1) {
                for (let i = 0; i < newRange.length; i++) {
                    const { price, min_km, max_km } = newRange[i];

                    if (!price || !min_km || !max_km) {
                        toast.error(`All fields must be filled at row ${i + 1}`);
                        return;
                    }
                }
            }

            // Submit all filled rows (can skip empty if needed)
            for (let i = 0; i < newRange.length; i++) {
                const { price, min_km, max_km } = newRange[i];

                // Skip empty row if it's the only one
                if (!price && !min_km && !max_km && newRange.length === 1) {
                    continue;
                }

                const res = await fetch(`${url}/freedelivery`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        min_kilometer: min_km,
                        max_kilometer: max_km,
                        freedelivery_price: price,
                        status: 1,
                        user_id: userData.main_id,
                        user_name: userData.full_name,
                    }),
                });

                const result = await res.json();

                if (!res.ok) {
                    throw new Error(result.message || "Submission failed");
                }
            }

            setSubmittedRanges([...newRange]);
            setNewRange([{ price: "", min_km: "", max_km: "" }]);
            toast.success("Free delivery ranges submitted successfully!");
        } catch (error) {
            console.error("Error submitting:", error);
            toast.error("Error: " + error.message);
        }
    };



    const fetchDeliveryPayData = async () => {
        try {
            const response = await fetch(`${url}/deliverypaybefore/single/${isLoggedIn.main_id}`);
            const res = await response.json();
            setDeliveryPayData(res.help || {}); // similar to help structure
        } catch (error) {
            console.error("Error fetching delivery data:", error);
        }
    };

    const fetchGSTData = async () => {
        if (!isLoggedIn?.main_id) return;
        try {
            const res = await fetch(`${url}/gst/${isLoggedIn.main_id}`);
            const data = await res.json().catch(() => ({}));
            if (res.ok) {
                setGstData({
                    ...data,
                    gstPercent: data.gstPercent ?? "",
                });
            } else if (res.status === 404) {
                setGstData({ gstPercent: "" });
            }
        } catch (error) {
            console.warn("GST fetch failed:", error?.message || error);
            setGstData({ gstPercent: "" });
        }
    };

    const fetchpercentagewalletData = async () => {
        try {
            const res = await fetch(`${url}/wallet-usage/get`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const data = await res.json();
            if (res.ok) {
                setWalletUsage(data.data);
            }
        } catch (error) {
            console.error("Failed to fetch GST data", error);
        }
    };

    const fetchcheckcartwalletData = async () => {
        try {
            const res = await fetch(`${url}/cart-check/get`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const data = await res.json();
            if (res.ok) {
                setCheckData(data.data);
            }
        } catch (error) {
            console.error("Failed to fetch GST data", error);
        }
    };

    const handlePayrazorSubmit = async () => {
        try {
            const res = await fetch(`${url}/pay-razorpay`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    user_id: isLoggedIn.main_id,
                    user_name: isLoggedIn.full_name,
                    key_id: razorpayData.key_id,
                    key_secret: razorpayData.key_secret,
                    company_color: razorpayData.company_color,
                    company_name: razorpayData.company_name
                }),
            });
            const result = await res.json();
            if (res.ok) {
                toast.success("Payment Gateway saved successfully");
                fetchPaymentrazData();
                setEditPayment(false);
            } else {
                toast.error(result.message || "Failed to save payment gateway");
            }
        } catch (error) {
            console.error("Payment gateway save error:", error);
            toast.error("Error saving payment gateway");
        }
    };

    const validateWebsiteUrl = (url) => {
        const regex = /^https:\/\/.+[^\/\\]$/;
        return regex.test(url);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "website_link") {
            if (value && !validateWebsiteUrl(value)) {
                setErrors(prev => ({
                    ...prev,
                    website_link:
                        "URL must start with https:// and should not end with / or \\"
                }));
            } else {
                setErrors(prev => ({ ...prev, website_link: "" }));
            }
        }

        setFormData({ ...formData, [name]: value });
    };

    const handleGstChange = (e) => {
        setGstData({ ...gstData, gstPercent: e.target.value });
    };


    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setFormData({ ...formData, profilePic: file, orignal_logoname: null });
    };

    const handlePlaceChanged = () => {
        const place = autocompleteRef.current.getPlace();
        if (place && place.formatted_address) {
            setFormData((prev) => ({
                ...prev,
                google_address: place.formatted_address,
            }));
        }
    };

    const handleTextLogoChange = (e) => {
        setFormData({ ...formData, orignal_logoname: e.target.value, profilePic: null });
    };

    const handleMetaSubmit = async (customData, iconFile) => {
        try {
            const form = new FormData();
            const data = customData || help;
            console.log(iconFile)
            for (const key in data) {
                if (key === "scripts") {
                    form.append("scripts", JSON.stringify(data[key] || []));
                } else if (key !== "iconFile" && data[key] !== undefined && data[key] !== null) {
                    form.append(key, data[key]);
                }
            }
            if (iconFile) {
                form.append("icon", iconFile);
            }

            form.append("user_id", String(isLoggedIn.main_id));
            form.append("user_name", String(isLoggedIn.full_name));


            const method = userMetaData ? "PUT" : "POST";
            const endpoint = userMetaData
                ? `${url}/meta/${isLoggedIn.main_id}`
                : `${url}/meta`;

            const res = await fetch(endpoint, {
                method,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: form,
            });

            // ✅ Validate response type
            // const contentType = res.headers.get("content-type");
            // if (!contentType || !contentType.includes("application/json")) {
            //     const raw = await res.text();
            //     console.error("Received non-JSON:", raw);
            //     throw new Error("Server response was not JSON");
            // }

            const result = await res.json();


            if (res.ok) {
                toast.success("Meta info saved successfully");
                fetchMetaData();

            } else {
                toast.error(result.message || "Failed to save meta info");
            }
        } catch (error) {
            console.error("Meta save error:", error);
            toast.error("Error saving meta info");
        }
    };


    const handleSubmit = async () => {
        if (
            formData.website_link &&
            !validateWebsiteUrl(formData.website_link)
        ) {
            toast.error(
                "Website URL must start with https:// and must not end with / or \\"
            );
            return; // ⛔ STOP API CALL
        }
        const form = new FormData();
        for (let key in formData) {
            if (formData[key] !== null) form.append(key, formData[key]);
        }

        try {
            const res = await fetch(`${url}/register/change`, {
                method: "PUT",
                mode: "cors",
                credentials: "include",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: form,

            });
            const data = await res.json();
            console.log(data)
            toast.success("Profile updated successfully");
            setEditMode(false);
            fetchSingleuser();
        } catch (err) {
            console.error("Update error:", err);
        }
    };

    const handleHelpSubmit = async () => {
        try {
            const method = userDatahelp ? "PUT" : "POST";
            const endpoint = userDatahelp
                ? `${url}/help/${isLoggedIn.main_id}`
                : `${url}/help`;

            const response = await fetch(endpoint, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    ...help,
                    user_id: isLoggedIn.main_id,
                    user_name: isLoggedIn.full_name
                }),
            });

            const result = await response.json();

            if (response.ok) {
                toast.success(`Help info ${userDatahelp ? "updated" : "created"} successfully`);
                setUserDatahelp({ ...help });
                setHelp({ ...help });
                setEditMode1(false);
            } else {
                toast.error(result.message || "Failed to save help info");
            }
        } catch (error) {
            console.error("Help save error:", error);
            toast.error("Error saving help info");
        }
    };

    const handleEmailpassSubmit = async () => {
        try {
            const method = "POST";
            const endpoint = `${url}/login-cred`;

            const response = await fetch(endpoint, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    ...Emailpass,
                    user_id: isLoggedIn.main_id,
                    user_name: isLoggedIn.full_name
                }),
            });

            const result = await response.json();

            if (response.ok) {
                toast.success(`Details saved successfully`);
                setUserDatahelp(help);
                setEditMode1(false);
            } else {
                toast.error(result.message || "Failed to save help info");
            }
        } catch (error) {
            console.error("Help save error:", error);
            toast.error("Error saving help info");
        }
    };

    const handleDeliveryPaySubmit = async () => {
        try {
            const method = deliveryPayData?.id ? "PUT" : "POST";
            const endpoint = deliveryPayData?.id
                ? `${url}/deliverypaybefore/${isLoggedIn.main_id}`
                : `${url}/deliverypaybefore`;

            const response = await fetch(endpoint, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    ...deliveryPayData,
                    user_id: isLoggedIn.main_id,
                    user_name: isLoggedIn.full_name,
                }),
            });

            const result = await response.json();
            if (response.ok) {
                toast.success(`Delivery policy ${method === "POST" ? "created" : "updated"} successfully`);
                setEditDelivery(false);
                fetchDeliveryPayData();
            } else {
                toast.error(result.message || "Failed to save delivery policy");
            }
        } catch (error) {
            toast.error("Error saving delivery policy");
            console.error(error);
        }
    };

    useEffect(() => {
        if (editMode && window.google && autocompleteRef.current) {
            const autocomplete = new window.google.maps.places.Autocomplete(autocompleteRef.current, {
                types: ["geocode"],
                componentRestrictions: { country: "in" }, // Optional: restrict to India
            });

            autocomplete.addListener("place_changed", () => {
                const place = autocomplete.getPlace();
                if (place.formatted_address) {
                    setFormData((prev) => ({
                        ...prev,
                        google_address: place.formatted_address,
                    }));
                }
            });
        }
    }, [editMode]);

    const deleteRange = async (id) => {
        if (!window.confirm("Delete this range?")) return;
        const res = await fetch(`${url}/freedelivery/${id}`, { method: "DELETE" });
        const result = await res.json();
        if (!res.ok) return toast.error("Delete failed");

        setDeliveryRanges(prev => prev.filter(r => r.id !== id));
    };


    // useEffect(() => {
    //     fetch(`${url}/freedelivery/${isLoggedIn.main_id}`)
    //         .then(res => res.json())
    //         .then(data => {
    //             if (!data.isError) {
    //                 setDeliveryRanges(data.data);
    //             }
    //         });
    // }, []);


    useEffect(() => {
        const fetchFreedeliveryRanges = async () => {
            if (!isLoggedIn?.main_id) return;
            try {
                const res = await fetch(`${url}/freedelivery/${isLoggedIn.main_id}`);
                const data = await res.json();
                if (!data.isError) setDeliveryRanges(data.data);
            } catch {
                /* ignore network errors — same as other setting fetches */
            }
        };

        const loadData = async () => {
            if (!isLoggedIn?.main_id) return;
            setLoading(true);
            try {
                await Promise.all([
                    fetchSingleuser(),
                    fetchHelpuser(),
                    fetchEmailpassuser(),
                    fetchDeliveryPayData(),
                    fetchGSTData(),
                    fetchpercentagewalletData(),
                    fetchMetaData().catch(() => {}),
                    fetchcheckcartwalletData(),
                    fetchsmssetting(),
                    fetchregistersetting(),
                    cartOption(),
                    paymentOption(),
                    fetchPaymentrazData(),
                    fetchFreedeliveryRanges(),
                ]);
            } catch (error) {
                console.warn("Error loading settings:", error?.message || error);
                toast.error("Error loading settings");
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, []);


    const removeDeliveryRange = (index) => {
        setNewRange((prev) => prev.filter((_, i) => i !== index));
    };

    const cartOption = async () => {
        try {
            const response = await fetch(`${url}/button/${isLoggedIn.main_id}`)
            const res = await response.json();
            console.log(res.data);
            setCartButtons(res.data);
        } catch (error) {
            console.error(error)
        }
    }

    const paymentOption = async () => {
        try {
            const response = await fetch(`${url}/paybutton/${isLoggedIn.main_id}`)
            const res = await response.json();
            console.log(res.data);
            setPayButtons(res.data);
        } catch (error) {
            console.error(error)
        }
    }


    const handleSaveEdit = async () => {
        if (!editButtonData) return;

        const { id, button, default: isDefault } = editButtonData;

        const trimmedButton = typeof button === "string" ? button.trim() : button;
        if (!trimmedButton) {
            toast.error("Button name is required");
            return;
        }

        try {
            // Base update
            const updates = [{ id, button: trimmedButton, default: !!isDefault }];

            // Only one cart button can be the default at a time. When this one is set
            // as default, unset every other button so the storefront has a single,
            // unambiguous default to render.
            if (isDefault) {
                cartButtons.forEach(b => {
                    if (b.id !== id && b.default) {
                        updates.push({ id: b.id, default: false });
                    }
                });
            }

            // Send batch update
            const response = await fetch(`${url}/button/api/update-cart-buttons`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates }),
            });

            // The endpoint may return a non-JSON body (proxy/404/HTML); guard against it
            // so a successful save is not reported as an error and vice-versa.
            let result = {};
            try {
                result = await response.json();
            } catch {
                result = {};
            }

            if (response.ok && !result.isError) {
                // Re-fetch from the server so the table reflects the persisted state
                // (instead of only an optimistic local merge).
                await cartOption();
                setEditButtonData(null);
                toast.success("Cart button updated");
            } else {
                toast.error(result?.message || "Failed to update");
            }

        } catch (err) {
            console.error(err);
            toast.error("Error occurred");
        }
    };


    const handleSavePaymentEdit = async () => {
        if (!editpayButtonData) return;

        const { id, button_id, button, default: isDefault } = editpayButtonData;

        const trimmedButton = typeof button === "string" ? button.trim() : button;
        if (!trimmedButton) {
            toast.error("Button name is required");
            return;
        }

        const normalizedId =
            button_id === "paymanual" ? "manualpay" : button_id;

        try {
            const updates = [{ id, button: trimmedButton, default: !!isDefault }];

            // Pay Now + Pay on delivery can both be shown at checkout.
            // Manual Payment is exclusive — enabling it disables the others, and
            // enabling any other method disables Manual Payment.
            if (isDefault) {
                if (normalizedId === "manualpay") {
                    payButtons.forEach((b) => {
                        if (b.id !== id && b.default) {
                            updates.push({ id: b.id, default: false });
                        }
                    });
                } else {
                    payButtons.forEach((b) => {
                        const otherId =
                            b.button_id === "paymanual" ? "manualpay" : b.button_id;
                        if (b.id !== id && otherId === "manualpay" && b.default) {
                            updates.push({ id: b.id, default: false });
                        }
                    });
                }
            }

            const response = await fetch(`${url}/paybutton/api/update-cart-buttons`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates }),
            });

            let result = {};
            try {
                result = await response.json();
            } catch {
                result = {};
            }

            if (response.ok && !result.isError) {
                await paymentOption();
                setpayEditButtonData(null);
                toast.success("Payment button updated");
            } else {
                toast.error(result?.message || "Failed to update");
            }

        } catch (err) {
            console.error(err);
            toast.error("Error occurred");
        }
    };

    const handleGstSubmit = async () => {
        try {
            const res = await fetch(`${url}/gst`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    user_id: isLoggedIn.main_id,
                    user_name: isLoggedIn.full_name,
                    gstPercent: gstData.gstPercent,
                }),
            });
            const result = await res.json();
            if (res.ok) {
                toast.success("GST saved successfully");
                fetchGSTData();
                setEditGst(false);
            } else {
                toast.error(result.message || "Failed to save GST");
            }
        } catch (error) {
            console.error("GST save error:", error);
            toast.error("Error saving GST");
        }
    };

    const handleWalletSubmit = async (updated) => {
        setWalletUsage(updated);
        try {
            const res = await fetch(`${url}/wallet-usage`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    percentage: updated.percentage,
                }),
            });
            const result = await res.json();
            if (res.ok) {
                toast.success(`${result.message}`);
                fetchpercentagewalletData();
            } else {
                toast.error(result.message || "Failed to save GST");
            }
        } catch (error) {
            console.error("GST save error:", error);
            toast.error("Error saving GST");
        }
    };

    const handleSmsSubmit = async (updated) => {
        setSms(updated);
        try {
            const res = await fetch(`${url}/sms`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    account_sid: updated.account_sid,
                    auth_token: updated.auth_token,
                    phone_number: updated.phone_number
                }),
            });
            const result = await res.json();
            if (res.ok) {
                toast.success(`${result.message}`);
                fetchsmssetting();
            } else {
                toast.error(result.message || "Failed to save SMS");
            }
        } catch (error) {
            console.error("error:", error);
            toast.error("Error saving SMS");
        }
    };

    // console.log(help)
    const handleRegisterSubmit = async (updated) => {
        setRegisterSetting({
            email: updated.email,
            phone: updated.phone
        });
        try {
            const res = await fetch(`${url}/register-setting`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    email: updated.email,
                    phone: updated.phone,
                }),
            });
            const result = await res.json();
            if (res.ok) {
                toast.success(`${result.message}`);
                fetchregistersetting();
            } else {
                toast.error(result.message || "Failed to save SMS");
            }
        } catch (error) {
            console.error("error:", error);
            toast.error("Error saving SMS");
        }
    };

    const handleCartCheckSubmit = async (updated) => {
        setWalletUsage(updated);
        try {
            const res = await fetch(`${url}/cart-check`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    coupon_apply: updated.coupon_apply,
                    coin_apply: updated.coin_apply
                }),
            });
            const result = await res.json();
            if (res.ok) {
                toast.success(`${result.message}`);
                fetchcheckcartwalletData();
            } else {
                toast.error(result.message || "Failed to save GST");
            }
        } catch (error) {
            console.error("GST save error:", error);
            toast.error("Error saving GST");
        }
    };

    const fetchPaymentrazData = async () => {
        try {
            const res = await fetch(`${url}/pay-razorpay/${isLoggedIn.main_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await res.json();
            if (res.ok) {
                setRazorpayData(data);
            }
        } catch (error) {
            console.error("Failed to fetch GST data", error);
        }
    };

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const response = await fetch(`${url}/two-step/status/${isLoggedIn.main_id}`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });
                const res = await response.json();
                if (response.ok) {
                    setEnabled(res.verify); // set toggle based on backend
                }
            } catch (error) {
                console.error(error);
            }
        };
        fetchStatus();
    }, []);


    // if (!userData) return <p className="hbtecom-loading">Loading...</p>;


    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const handleCombinedSubmit = async () => {
        // ✅ Only validate if more than one row
        if (newRange.length > 1) {
            const incompleteRows = newRange.filter(
                (r) =>
                    !r.min_km?.toString().trim() ||
                    !r.max_km?.toString().trim() ||
                    !r.price?.toString().trim()
            );

            if (incompleteRows.length > 0) {
                toast.error("Please fill all fields in each delivery range row.");
                return; // prevent submission
            }
        }

        try {
            await handleDeliveryPaySubmit();   // Save delivery percent
            await submitDeliveryRanges();      // Save new ranges
            toast.success("Delivery settings updated.");
        } catch (error) {
            toast.error("Error saving delivery settings.");
            console.error(error);
        }
    };



    if (loading) {
        return (
            <Loader />
        );
    }


    return (
        <>
            <motion.div
                className="admin-accordion-container"
                layout
                transition={{ layout: { duration: 0.4, ease: "easeInOut" } }}
            >
                <h2 className="admin-accordion-heading">Settings Configuration</h2>

                {tabList.map((item, index) => {
                    return <motion.div key={index} className="admin-accordion-item" layout>

                        <button
                            className="admin-accordion-header"
                            onClick={() => toggleAccordion(index)}
                        >
                            <span>{item}</span>
                            {activeIndex === index ? <><ChevronUp size={20} /></> : <><ChevronDown size={20} /></>}
                        </button>
                        <AnimatePresence initial={false}>
                            {activeIndex === index && (
                                <motion.div
                                    className="admin-accordion-content"
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    style={{ overflow: "hidden" }}
                                >
                                    {index === 0 && (
                                        <div>
                                            <ProfileSetting
                                                formData={formData}
                                                handleChange={handleChange}
                                                useTextLogo={useTextLogo}
                                                setUseTextLogo={setUseTextLogo}
                                                handleLogoChange={handleLogoChange}
                                                handleTextLogoChange={handleTextLogoChange}
                                                isLoaded={isLoaded}
                                                Autocomplete={Autocomplete}
                                                autocompleteRef={autocompleteRef}
                                                handlePlaceChanged={handlePlaceChanged}
                                                ReactQuill={ReactQuill}
                                                setFormData={setFormData}
                                                originalFormData={originalFormData}
                                                handleSubmit={handleSubmit}
                                                error={error}
                                            />
                                        </div>
                                    )}

                                    {index === 1 && (
                                        <HelpAndSupport
                                            helpData={help}
                                            setHelpData={setHelp}
                                            originalHelpData={userDatahelp}
                                            handleHelpSubmit={handleHelpSubmit}
                                        />
                                    )}

                                    {index === 2 && (
                                        <DeliverySettings
                                            deliveryPayData={deliveryPayData}
                                            setDeliveryPayData={setDeliveryPayData}
                                            newRange={newRange}
                                            setNewRange={setNewRange}
                                            handleCombinedSubmit={handleCombinedSubmit}
                                            deliveryRanges={deliveryRanges}
                                            deleteRange={deleteRange}
                                        />
                                    )}

                                    {index === 3 && (
                                        <CartButtonOptions
                                            cartButtons={cartButtons}
                                            editButtonData={editButtonData}
                                            setEditButtonData={setEditButtonData}
                                            handleSaveEdit={handleSaveEdit}
                                        />
                                    )}

                                    {index === 4 && (
                                        <PaymentButtonOptions
                                            payButtons={payButtons}
                                            editpayButtonData={editpayButtonData}
                                            setpayEditButtonData={setpayEditButtonData}
                                            handleSavePaymentEdit={handleSavePaymentEdit}
                                        />
                                    )}

                                    {index === 5 && (
                                        <GstInlineSetting
                                            gstData={gstData}
                                            setGstData={setGstData}
                                            handleGstSubmit={async (updated) => {
                                                setGstData(updated);
                                                try {
                                                    const res = await fetch(`${url}/gst`, {
                                                        method: "POST",
                                                        headers: {
                                                            "Content-Type": "application/json",
                                                            Authorization: `Bearer ${token}`,
                                                        },
                                                        body: JSON.stringify({
                                                            user_id: isLoggedIn.main_id,
                                                            user_name: isLoggedIn.full_name,
                                                            gstPercent: updated.gstPercent,
                                                        }),
                                                    });

                                                    const result = await res.json();
                                                    if (res.ok) {
                                                        toast.success("GST saved successfully");
                                                        fetchGSTData();
                                                    } else {
                                                        toast.error(result.message || "Failed to save GST");
                                                    }
                                                } catch (error) {
                                                    console.error("GST save error:", error);
                                                    toast.error("Error saving GST");
                                                }
                                            }}
                                        />
                                    )}

                                    {index === 6 && (
                                        <MetaDetails
                                            helpData={meta}
                                            setHelpData={setMeta}
                                            originalHelpData={userMetaData}
                                            handleHelpSubmit={handleMetaSubmit}
                                        />
                                    )}

                                    {index === 7 && (
                                        <PaymentGateway
                                            guestData={razorpayData}
                                            setGuestData={setRazorpayData}
                                            handleGuestSubmit={handlePayrazorSubmit}
                                        />
                                    )}

                                    {index === 8 && (
                                        <LoginPass
                                            helpData={Emailpass}
                                            setHelpData={setEmailPass}
                                            originalHelpData={Emailpasshelp}
                                            handleHelpSubmit={handleEmailpassSubmit}
                                        />
                                    )}
                                    {index === 9 && (
                                        <WalletUsageSetting
                                            gstData={walletUsage}
                                            setGstData={setWalletUsage}
                                            handleGstSubmit={handleWalletSubmit}
                                        />
                                    )}
                                    {index === 10 && (
                                        <CartCheckSetting
                                            cartCheckData={checkData}
                                            setGstData={setCheckData}
                                            handleSave={handleCartCheckSubmit}
                                        />
                                    )}
                                    {index === 11 && (
                                        <RegisterSetting
                                            cartCheckData={registerSetting}
                                            setGstData={setRegisterSetting}
                                            handleSave={handleRegisterSubmit}
                                        />
                                    )}
                                    {index === 12 && (
                                        <SMSSetting
                                            helpData={sms}
                                            setHelpData={setSms}
                                            originalHelpData={sms}
                                            handleHelpSubmit={handleSmsSubmit}
                                        />
                                    )}
                                    {index === 13 && (
                                        <SettingsBankAndSign
                                            enabled={enabled}
                                            setEnabled={setEnabled}
                                        />
                                    )}
                                    {index === 14 && (
                                        <LoginBanner
                                            helpData={Emailpass}
                                            setHelpData={setEmailPass}
                                            originalHelpData={Emailpasshelp}
                                            handleHelpSubmit={handleEmailpassSubmit}
                                        />
                                    )}
                                    {index === 15 && (
                                        <TwoStepVerification
                                            enabled={enabled}
                                            setEnabled={setEnabled}
                                        />
                                    )}

                                </motion.div>
                            )}
                        </AnimatePresence>
                    </motion.div>
                })}

            </motion.div>
        </>
    );
};

export default SettingUpdated;
